// extracted by mini-css-extract-plugin
export default {"actionsView":"styles_actionsView__t-L2q","singleAction":"styles_singleAction__Wh7BD","ui-spin":"styles_ui-spin__tSnXb"};